import {    GET_AVALARA_RETURN_REQUEST,
	GET_AVALARA_RETURN_SUCCESS,
	GET_AVALARA_RETURN_ERROR} from "../actions/types";

export default function (state = [], action) {
	const { type, payload } = action;
	switch (type) {
		case GET_AVALARA_RETURN_REQUEST:
			return {
				loading: true,
			};
		case GET_AVALARA_RETURN_SUCCESS:
			return {
				...state,
				loading: false,
				payload
						};
		case GET_AVALARA_RETURN_ERROR:
			return {
				...state,
				loading: false,
				payload,
			};

		default:
			return state;
	}
}
